export const compliantImg = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.2917 13.3371C17.5853 12.5023 18.165 11.7983 18.9279 11.35C19.6908 10.9016 20.5878 10.7377 21.46 10.8873C22.3322 11.0369 23.1233 11.4903 23.6932 12.1673C24.2631 12.8443 24.5751 13.7012 24.5737 14.5861C24.5737 17.0843 20.8265 18.3333 20.8265 18.3333M20.8748 23.3333H20.8915M12.2917 30V33.8925C12.2917 34.7806 12.2917 35.2246 12.4737 35.4527C12.632 35.651 12.8721 35.7664 13.1259 35.7661C13.4177 35.7658 13.7645 35.4884 14.4579 34.9337L18.4337 31.7531C19.2459 31.1033 19.6519 30.7784 20.1041 30.5474C20.5053 30.3425 20.9324 30.1927 21.3737 30.1021C21.8711 30 22.3912 30 23.4312 30H27.625C30.4253 30 31.8254 30 32.895 29.455C33.8358 28.9757 34.6007 28.2108 35.08 27.27C35.625 26.2004 35.625 24.8003 35.625 22V13C35.625 10.1997 35.625 8.79961 35.08 7.73005C34.6007 6.78924 33.8358 6.02433 32.895 5.54497C31.8254 5 30.4253 5 27.625 5H13.625C10.8247 5 9.42461 5 8.35505 5.54497C7.41424 6.02433 6.64933 6.78924 6.16997 7.73005C5.625 8.79961 5.625 10.1997 5.625 13V23.3333C5.625 24.8833 5.625 25.6583 5.79537 26.2941C6.25771 28.0196 7.60544 29.3673 9.3309 29.8296C9.96674 30 10.7417 30 12.2917 30Z"
      stroke="url(#paint0_linear_6125_22468)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6125_22468"
        x1="13.2358"
        y1="8.41004"
        x2="29.6027"
        y2="50.0397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);

export const broadCastImg = (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M34.2216 27.6908V9.22927V6.15234C35.9139 6.15234 37.2985 7.53696 37.2985 9.22927V27.6908C37.2985 29.3831 35.9139 30.7677 34.2216 30.7677H12.6831L6.5293 36.9216L6.53343 29.4908V26.1523H9.60622V29.4908L11.4062 27.6908H34.2216Z"
      fill="url(#paint0_linear_6125_22460)"
    />
    <path
      d="M40.3749 33.8471V15.3855V12.3086C42.0672 12.3086 43.4518 13.6932 43.4518 15.3855V33.8471C43.4518 35.5394 42.0672 36.924 40.3749 36.924H18.8365L12.6826 43.0778L12.6867 35.6471V32.3086H15.7595V35.6471L17.5595 33.8471H40.3749Z"
      fill="url(#paint1_linear_6125_22460)"
    />
    <path
      d="M3.45192 3.07692H28.0673V21.5385H5.25192L3.45192 23.3385V3.07692ZM3.45192 0C1.75962 0 0.390385 1.38462 0.390385 3.07692L0.375 30.7692L6.52885 24.6154H28.0673C29.7596 24.6154 31.1442 23.2308 31.1442 21.5385V3.07692C31.1442 1.38462 29.7596 0 28.0673 0H3.45192ZM6.52885 15.3846H24.9904V18.4615H6.52885V15.3846ZM6.52885 10.7692H24.9904V13.8462H6.52885V10.7692ZM6.52885 6.15385H24.9904V9.23077H6.52885V6.15385Z"
      fill="url(#paint2_linear_6125_22460)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6125_22460"
        x1="14.3353"
        y1="9.56273"
        x2="30.402"
        y2="51.4725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6125_22460"
        x1="20.4886"
        y1="15.719"
        x2="36.5553"
        y2="57.6288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6125_22460"
        x1="8.18099"
        y1="3.41038"
        x2="24.2477"
        y2="45.3202"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);

export const visitorsImg = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.5413 30L30.8747 33.3333L37.5413 26.6667M20.8747 25H14.208C11.1017 25 9.54859 25 8.32345 25.5075C6.68993 26.1841 5.3921 27.4819 4.71548 29.1154C4.20801 30.3406 4.20801 31.8937 4.20801 35M26.708 5.4846C29.1512 6.47358 30.8747 8.86885 30.8747 11.6667C30.8747 14.4645 29.1512 16.8598 26.708 17.8487M23.3747 11.6667C23.3747 15.3486 20.3899 18.3333 16.708 18.3333C13.0261 18.3333 10.0413 15.3486 10.0413 11.6667C10.0413 7.98477 13.0261 5 16.708 5C20.3899 5 23.3747 7.98477 23.3747 11.6667Z"
      stroke="url(#paint0_linear_6125_22454)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6125_22454"
        x1="12.6645"
        y1="8.32512"
        x2="27.1148"
        y2="50.2068"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);

export const financesImg = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.2913 16.6654H3.95801M18.958 23.332H10.6247M3.95801 13.6654L3.95801 26.332C3.95801 28.1989 3.95801 29.1323 4.32132 29.8453C4.6409 30.4725 5.15083 30.9825 5.77804 31.3021C6.49108 31.6654 7.4245 31.6654 9.29134 31.6654L31.958 31.6654C33.8249 31.6654 34.7583 31.6654 35.4713 31.3021C36.0985 30.9825 36.6085 30.4725 36.928 29.8453C37.2913 29.1323 37.2913 28.1989 37.2913 26.332V13.6654C37.2913 11.7985 37.2913 10.8651 36.928 10.1521C36.6085 9.52486 36.0985 9.01492 35.4713 8.69535C34.7583 8.33203 33.8249 8.33203 31.958 8.33203L9.29134 8.33203C7.4245 8.33203 6.49108 8.33203 5.77804 8.69534C5.15083 9.01492 4.6409 9.52486 4.32132 10.1521C3.95801 10.8651 3.95801 11.7985 3.95801 13.6654Z"
      stroke="url(#paint0_linear_6125_22449)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6125_22449"
        x1="12.4145"
        y1="10.9182"
        x2="21.5395"
        y2="44.922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);

export const residentImg = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.3747 13.1854H30.158C27.008 13.0854 24.658 10.652 24.658 7.65203C24.658 4.58536 27.158 2.10203 30.208 2.10203C33.258 2.10203 35.758 4.60203 35.758 7.65203C35.7601 9.09314 35.201 10.4784 34.1992 11.5144C33.1974 12.5504 31.8317 13.1557 30.3913 13.202C30.3913 13.1854 30.3913 13.1854 30.3747 13.1854ZM30.208 4.58536C28.5247 4.58536 27.158 5.95203 27.158 7.63536C27.158 9.28536 28.4413 10.6187 30.0913 10.6854C30.108 10.6687 30.2413 10.6687 30.3913 10.6854C31.1805 10.6333 31.9187 10.2771 32.4505 9.69173C32.9823 9.10633 33.2662 8.33744 33.2424 7.54692C33.2186 6.75641 32.8891 6.00595 32.3231 5.45355C31.7571 4.90115 30.9989 4.58991 30.208 4.58536ZM30.3897 25.4654C29.7397 25.4654 29.0897 25.4154 28.4397 25.2987C28.2776 25.2705 28.1226 25.2106 27.9837 25.1224C27.8449 25.0342 27.7247 24.9195 27.6303 24.7848C27.5358 24.6501 27.4689 24.498 27.4333 24.3374C27.3978 24.1768 27.3943 24.0107 27.423 23.8487C27.4512 23.6866 27.5111 23.5317 27.5993 23.3928C27.6875 23.2539 27.8022 23.1338 27.9369 23.0393C28.0716 22.9449 28.2237 22.8779 28.3843 22.8424C28.5449 22.8068 28.711 22.8033 28.873 22.832C30.923 23.182 33.0897 22.7987 34.5397 21.832C35.323 21.3154 35.7397 20.6654 35.7397 20.0154C35.7397 19.3654 35.3063 18.732 34.5397 18.2154C33.0897 17.2487 30.8897 16.8654 28.823 17.232C28.1397 17.3654 27.4897 16.8987 27.373 16.2154C27.2563 15.532 27.7063 14.882 28.3897 14.7654C31.1063 14.282 33.923 14.7987 35.923 16.132C37.3897 17.1154 38.2397 18.5154 38.2397 20.0154C38.2397 21.4987 37.4063 22.9154 35.923 23.9154C34.4063 24.9154 32.4397 25.4654 30.3897 25.4654ZM10.3247 13.182H10.2913C8.85344 13.137 7.48944 12.5344 6.48787 11.5018C5.48629 10.4691 4.9257 9.0873 4.92467 7.6487C4.92467 4.58203 7.42467 2.08203 10.4747 2.08203C13.5247 2.08203 16.0247 4.58203 16.0247 7.63203C16.0247 10.6487 13.6747 13.082 10.6747 13.182L10.3247 11.932L10.4413 13.182H10.3247ZM10.4913 10.682C10.5913 10.682 10.6747 10.682 10.7747 10.6987C12.258 10.632 13.558 9.2987 13.558 7.6487C13.5571 7.05276 13.3817 6.47014 13.0533 5.97281C12.725 5.47548 12.2581 5.08524 11.7105 4.85029C11.1628 4.61534 10.5583 4.54599 9.97163 4.65079C9.38498 4.75559 8.84188 5.02996 8.40944 5.44C7.97699 5.85004 7.67414 6.37779 7.5383 6.95804C7.40246 7.53829 7.43959 8.14563 7.64509 8.70502C7.8506 9.2644 8.21547 9.75133 8.69465 10.1056C9.17382 10.46 9.74629 10.6661 10.3413 10.6987C10.358 10.682 10.4247 10.682 10.4913 10.682ZM10.308 25.4654C8.25801 25.4654 6.29134 24.9154 4.77467 23.9154C3.30801 22.932 2.45801 21.5154 2.45801 20.0154C2.45801 18.532 3.30801 17.1154 4.77467 16.132C6.77467 14.7987 9.59134 14.282 12.308 14.7654C12.9913 14.882 13.4413 15.532 13.3247 16.2154C13.208 16.8987 12.558 17.3654 11.8747 17.232C9.80801 16.8654 7.62467 17.2487 6.15801 18.2154C5.37467 18.732 4.95801 19.3654 4.95801 20.0154C4.95801 20.6654 5.39134 21.3154 6.15801 21.832C7.60801 22.7987 9.77467 23.182 11.8247 22.832C12.508 22.7154 13.158 23.182 13.2747 23.8487C13.3913 24.532 12.9413 25.182 12.258 25.2987C11.608 25.4154 10.958 25.4654 10.308 25.4654ZM20.3747 25.632H20.158C17.008 25.532 14.658 23.0987 14.658 20.0987C14.658 17.032 17.158 14.5487 20.208 14.5487C23.258 14.5487 25.758 17.0487 25.758 20.0987C25.7601 21.5398 25.201 22.9251 24.1992 23.9611C23.1974 24.9971 21.8317 25.6024 20.3913 25.6487C20.3913 25.632 20.3913 25.632 20.3747 25.632ZM20.208 17.032C18.5247 17.032 17.158 18.3987 17.158 20.082C17.158 21.732 18.4413 23.0654 20.0913 23.132C20.108 23.1154 20.2413 23.1154 20.3913 23.132C22.008 23.0487 23.258 21.7154 23.2747 20.082C23.2747 18.4154 21.908 17.032 20.208 17.032ZM20.3763 37.9304C18.3763 37.9304 16.3763 37.4137 14.8263 36.3637C13.3597 35.3804 12.5097 33.9804 12.5097 32.4804C12.5097 30.997 13.343 29.5637 14.8263 28.5804C17.943 26.5137 22.8263 26.5137 25.9263 28.5804C27.393 29.5637 28.243 30.9637 28.243 32.4637C28.243 33.947 27.4097 35.3804 25.9263 36.3637C24.3763 37.397 22.3763 37.9304 20.3763 37.9304ZM16.2097 30.6804C15.4263 31.197 15.0097 31.847 15.0097 32.497C15.0097 33.147 15.443 33.7804 16.2097 34.297C18.4597 35.8137 22.2763 35.8137 24.5263 34.297C25.3097 33.7804 25.7263 33.1304 25.7263 32.4804C25.7263 31.8304 25.293 31.197 24.5263 30.6804C22.293 29.1637 18.4763 29.1804 16.2097 30.6804Z"
      fill="url(#paint0_linear_6125_22443)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6125_22443"
        x1="11.5356"
        y1="6.05537"
        x2="30.2804"
        y2="54.8599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);

export const houseImg = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.125 36.6654V19.9987H25.125V36.6654M5.125 14.9987L20.125 3.33203L35.125 14.9987V33.332C35.125 34.2161 34.7738 35.0639 34.1487 35.6891C33.5236 36.3142 32.6757 36.6654 31.7917 36.6654H8.45833C7.57428 36.6654 6.72643 36.3142 6.10131 35.6891C5.47619 35.0639 5.125 34.2161 5.125 33.332V14.9987Z"
      stroke="url(#paint0_linear_8151_3160)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_8151_3160"
        x1="12.7358"
        y1="7.02661"
        x2="31.5111"
        y2="51.1041"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#268D8E" />
        <stop offset="1" stopColor="#8037D7" />
      </linearGradient>
    </defs>
  </svg>
);
